import React from "react"
import { Link } from "gatsby"
import { withTheme } from "emotion-theming"
import { lighten, readableColor } from "polished"

import { Row, Col } from "@components/grid"
import Panel from "@components/panel"
import { Caption } from "@components/type"

import { useSiteMetadata } from "@hooks/useSiteMetadata"

import { rhythm } from "@utils/typography"

import Facebook from "@svgs/facebook"
import Instagram from "@svgs/instagram"
import Twitter from "@svgs/twitter"

import Cable from "@images/logos/cable-14.png"
import CHCH from "@images/logos/chch.svg"
import HamiltonNews from "@images/logos/hamilton-news.png"
import Spectator from "@images/logos/spectator.png"

import { IconLink, Label, Text, Wrapper } from "./styles"

const Footer = ({ theme }) => {
  const {
    title,
    social: { instagram, twitter, facebook },
  } = useSiteMetadata()
  const logoStyle = { maxHeight: "48px" }
  return (
    <footer>
      <Panel maxWidth="1600px">
        <Caption align="center" style={{ marginBottom: rhythm(1.5) }}>
          Special Thanks to Our Media Partners
        </Caption>
        <Row alignItems="center" justifyContent="space-around">
          <Col mb={0}>
            <img
              src={HamiltonNews}
              alt="Hamilton Community News"
              style={logoStyle}
            />
          </Col>
          <Col mb={0}>
            <img src={Cable} alt="Cable 14" style={logoStyle} />
          </Col>
          <Col mb={0}>
            <img src={CHCH} alt="CHCH" style={logoStyle} />
          </Col>
          <Col mb={0}>
            <img
              src={Spectator}
              alt="The Hamilton Spectator"
              style={logoStyle}
            />
          </Col>
        </Row>
      </Panel>
      <Panel background={theme.colours.primary} style={{ textAlign: "center" }}>
        <Row justifyContent="center">
          <Col width={[1, 1, 1 / 3]}>
            <Label>Address</Label>
            <Text>
              28 Athens Street
              <br />
              Hamilton, ON L9C 3K9
            </Text>
          </Col>
          <Col width={[1, 1, 1 / 3]}>
            <Label>Contact</Label>
            <Text>
              Phone: 905 574 1334
              <br />
              Fax: 905 574 1688
            </Text>
          </Col>
          <Col width={[1, 1, 1 / 3]}>
            <Label>Follow Us On</Label>
            <Text>
              <IconLink href={`https://twitter.com/${twitter}`}>
                <Twitter colour={readableColor(theme.colours.primary)} />@
                {twitter}
              </IconLink>
              <IconLink href={`https://facebook.com/${facebook}`}>
                <Facebook colour={readableColor(theme.colours.primary)} />@
                {facebook}
              </IconLink>
              <IconLink href={`https://instagram.com/${instagram}`}>
                <Instagram colour={readableColor(theme.colours.primary)} />@
                {instagram}
              </IconLink>
            </Text>
          </Col>
        </Row>
      </Panel>
      <Wrapper background={lighten(0.02, theme.colours.primary)}>
        <p>
          <a href="http://www.n2ncentre.com/">n2ncentre.com</a>
        </p>
        &copy;{" "}
        <Link to="/">
          {new Date().getFullYear()} {title}
        </Link>
        . Report by <a href="https://floating-point.com">floating-point</a>.
      </Wrapper>
    </footer>
  )
}

export default withTheme(Footer)
